import { useEffect, useState } from 'react';

// 0 where scrollbars overlay the page. The probe sits off-screen and is added and
// removed in the same task, before the browser paints, so no scrollbar ever shows.
const measureScrollbarWidth = () => {
  const probe = document.createElement('div');
  probe.style.cssText = 'position:absolute;top:-9999px;width:100px;height:100px;overflow:scroll;';
  document.body.appendChild(probe);
  const width = probe.offsetWidth - probe.clientWidth;
  document.body.removeChild(probe);
  return width;
};

// Leaves the scrollbar out even while the page does not scroll, so the width does not
// change when a layout change makes the scrollbar appear or disappear.
const useWidthBesideScrollbar = () => {
  const [scrollbarWidth] = useState(measureScrollbarWidth);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth - scrollbarWidth;
};

export default useWidthBesideScrollbar;
